import { useQuery } from "@tanstack/react-query";
import type { SellerPermission } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { queryKeys } from "@/lib/query/core/query-keys";

type RolePermissionsResponse = { permissions: SellerPermission[] };

export function useRolePermissionsQuery(storeSlug: string) {
  const query = useQuery({
    queryKey: queryKeys.seller.rolePermissions(storeSlug),
    queryFn: () =>
      apiJsonClient<RolePermissionsResponse>(endpoints.seller.rolePermissions),
    enabled: storeSlug.length > 0,
    // Permission set is static between deploys; cache aggressively.
    staleTime: 60 * 60 * 1000,
  });

  return {
    data: query.data?.permissions ?? [],
    isLoading: query.isLoading,
    error: query.error,
  };
}
